import { LANGUAGE_CODES, SERVICE_STATUS, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

export const createServiceSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  clinicId: z.string().uuid().optional().nullable(),
  name: z.string().min(2, VALIDATION_KEYS.SERVICE.NAME_REQUIRED),
  description: z.string().optional().nullable(),
  
  // Tiempos: Array de números (minutos)
  durations: z.array(z.number().int().positive())
    .min(1, VALIDATION_KEYS.SERVICE.DURATION_REQUIRED),
  defaultDuration: z.number().int().positive(VALIDATION_KEYS.GENERIC.NUMBER_POSITIVE),
  bufferTime: z.number().int().min(0).default(0),
  
  // Economí­a: Coerced para que acepte strings de inputs y los pase a number
  price: z.coerce.number().positive(VALIDATION_KEYS.SERVICE.REAL_PRICE),
  taxRate: z.coerce.number().min(0).max(100).default(0),
  
  // Relaciones y UI
  serviceCategoryId: z.string().uuid().optional().nullable(),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, VALIDATION_KEYS.GENERIC.INVALID_COLOR).nullable().optional(),
  icon: z.string().optional().nullable(),
  status: z.enum(SERVICE_STATUS).optional(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),

  // Flags
  isOnline: z.boolean().default(false),
  requiresApproval: z.boolean().default(false),
  capacity: z.number().int().positive().default(1),
  isOnboarding: z.boolean().optional().default(false),
  // ðŸŽ¯ El truco para los profesionales en el CREATE:
  // Recibimos solo los IDs, luego el Repository creará los ProfessionalService
 // professionalIds: z.array(z.string().uuid()).default([]),
});

export const updateServiceSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  clinicId: z.string().uuid().optional().nullable(),
  name: z.string().min(2, VALIDATION_KEYS.SERVICE.NAME_REQUIRED),
  description: z.string().optional().nullable(),
  
  // Tiempos: Array de números (minutos)
  durations: z.array(z.number().int().positive())
    .min(1, VALIDATION_KEYS.SERVICE.DURATION_REQUIRED),
  defaultDuration: z.number().int().positive("La duración por defecto es obligatoria"),
  bufferTime: z.number().int().min(0).default(0),
  
  // Economí­a: Coerced para que acepte strings de inputs y los pase a number
  price: z.coerce.number().positive(VALIDATION_KEYS.SERVICE.REAL_PRICE),
  taxRate: z.coerce.number().min(0).max(100).default(0),
  
  // Relaciones y UI
  serviceCategoryId: z.string().uuid().optional().nullable(),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, VALIDATION_KEYS.GENERIC.INVALID_COLOR).nullable().optional(),
  icon: z.string().optional().nullable(),
  status: z.enum(SERVICE_STATUS).optional(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),

  // Flags
  isOnline: z.boolean().default(false),
  requiresApproval: z.boolean().default(false),
  capacity: z.number().int().positive().default(1),

});

export const updateServiceProfessionalsSchema = z.object({
  professionalIds: z.array(z.string().uuid()),
}).strict();

export const createServiceTranslationSchema = createServiceSchema.partial();